import type { VehicleTag } from '@cobliteam/api-lib/src/__generated__/graphql';
import Badge from '@cobliteam/ui/components/Badge';
import type React from 'react';

interface VehicleTagsDisplayProps {
  tags: VehicleTag[];
}

const VehicleTagsDisplay: React.FC<VehicleTagsDisplayProps> = ({ tags }) => {
  if (!tags || tags.length === 0) {
    return null;
  }

  return (
    <div className='flex flex-wrap gap-2'>
      {tags.map((tag) => (
        <Badge key={tag.name} variant='surface' color='default'>
          {tag.name}
        </Badge>
      ))}
    </div>
  );
};

export default VehicleTagsDisplay;
